import React, { useState } from "react";

const DownArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.854 9.35375L8.35403 13.8538C8.30759 13.9002 8.25245 13.9371 8.19175 13.9623C8.13105 13.9874 8.06599 14.0004 8.00028 14.0004C7.93457 14.0004 7.86951 13.9874 7.80881 13.9623C7.74811 13.9371 7.69296 13.9002 7.64653 13.8538L3.14653 9.35375C3.05271 9.25993 3 9.13268 3 9C3 8.86732 3.05271 8.74007 3.14653 8.64625C3.24035 8.55243 3.3676 8.49972 3.50028 8.49972C3.63296 8.49972 3.76021 8.55243 3.85403 8.64625L7.50028 12.2931V2.5C7.50028 2.36739 7.55296 2.24021 7.64672 2.14645C7.74049 2.05268 7.86767 2 8.00028 2C8.13289 2 8.26006 2.05268 8.35383 2.14645C8.4476 2.24021 8.50028 2.36739 8.50028 2.5V12.2931L12.1465 8.64625C12.2403 8.55243 12.3676 8.49972 12.5003 8.49972C12.633 8.49972 12.7602 8.55243 12.854 8.64625C12.9478 8.74007 13.0006 8.86732 13.0006 9C13.0006 9.13268 12.9478 9.25993 12.854 9.35375Z"
      fill="#3399FF"
    />
  </svg>
);
const faqItems = [
  {
    value: "faq-1",
    question: "What are the typical CPA fees in Miles Education?",
    answer: (
      <>
        The Miles Education{" "}
        <a
          href="https://www.mileseducation.com/cpa/cpa-fees"
          target="_blank"
          className="text-[#39F] underline"
        >
          CPA fees
        </a>{" "}
        are structured across three phases:
        <ul className="mt-1.5 list-disc space-y-1 pl-4">
          <li>
            <strong>Phase I (Exam Preparation):</strong> INR 99,000 (CPA Review
            fees paid to Miles)
          </li>
          <li>
            <strong>Phase II (Evaluation & First Exam):</strong> ~$400 (INR
            34,400) for credential evaluation + ~$900 (INR 77,400) for the first
            exam fee.
          </li>
          <li>
            <strong>Phase III (Remaining 3 Exams):</strong> ~$2,700 (INR
            2,32,000) for the remaining exam fees paid to the U.S. State Boards.
          </li>
        </ul>
      </>
    ),
  },
  {
    value: "faq-2",
    question: "What can I expect from pursuing a CPA in Bangalore?",
    answer:
      "In Bangalore, Miles CPA offers an unparalleled learning experience with personalized mentorship, live face-to-face classes, and access to a global alumni network. Miles in Bangalore ensures that you are fully equipped to succeed. Whether you prefer interactive classroom learning or self-paced study via the app, Miles provides tailored support to navigate your CPA journey from Bangalore.",
  },
  {
    value: "faq-3",
    question: "What are the benefits of pursuing a CPA program in Chennai?",
    answer: (
      <>
        <a
          href="https://www.mileseducation.com/cpa/best-cpa-course-in-chennai"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          Miles CPA in Chennai
        </a>{" "}
        offers highly flexible options including live classroom sessions, online
        classes, and hybrid learning. Students can choose the format that best
        fits their schedule while receiving full 1:1 mentorship, official study
        resources, and global placement support.
      </>
    ),
  },
  {
    value: "faq-4",
    question: "Where can I pursue a CPA in Hyderabad?",
    answer: (
      <>
        You can{" "}
        <a
          href="https://www.mileseducation.com/cpa/cpa-course"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          pursue a CPA
        </a>{" "}
        with Miles in Hyderabad. Miles offers flexible online courses, live
        classroom classes, and personalized mentorship, ensuring that students
        in Hyderabad receive comprehensive support. Whether you prefer
        self-paced learning or guided face-to-face sessions, Miles provides all
        the resources needed to clear the exams.
      </>
    ),
  },
  {
    value: "faq-5",
    question: "Where can I take the CPA in Mumbai?",
    answer: (
      <>
        You can prepare for and take the{" "}
        <a
          href="https://www.mileseducation.com/cpa/cpa-exam"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          CPA exam
        </a>{" "}
        in Mumbai with support from Miles. Mumbai offers premier CPA preparation
        courses from Miles, and the city actually hosts official Prometric exam
        centers, making it an incredibly convenient location. With expert
        guidance and access to a robust alumni network, Miles ensures
        you&rsquo;re well-prepared.
      </>
    ),
  },
  {
    value: "faq-6",
    question: "Where can I prepare for the CPA in Kolkata?",
    answer:
      "One of Miles' premier offices is present in Kolkata, where you can enroll in preparatory CPA courses. With personalized mentorship, live classes, and access to the Gameplan team, Miles ensures that students in Kolkata are fully equipped to succeed.",
  },
  {
    value: "faq-7",
    question: "Where can I pursue the CPA in Pune and Ahmedabad?",
    answer:
      "You can seamlessly pursue your CPA in either Ahmedabad or Pune with Miles Education. Miles offers highly engaging online classes and one-on-one mentorship in these cities, providing expert guidance to help you prepare. You'll have access to high-quality McGraw-Hill study materials, live sessions, and a powerful alumni network.",
  },
];

const MilesCpaFAQ = () => {
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());

  const toggleExpand = (value: string) => {
    setExpandedItems((prev) => {
      const next = new Set(prev);
      if (next.has(value)) next.delete(value);
      else next.add(value);
      return next;
    });
  };
  const visibleItems = showAllFaqs ? faqItems : faqItems.slice(0, 3);
  return (
    <section className="w-full bg-[#F5F5F5] pt-3 pb-6 md:bg-white md:py-12">
      <div className="main_container">
        <div className="rounded-2xl bg-white p-4 shadow-sm md:rounded-none md:p-0 md:shadow-none">
          <h2 className="text-center text-[22px] font-bold tracking-[-1.76px] text-[#061A2F] md:text-[32px]">
            FAQS
          </h2>

          <div className="mx-auto mt-6 max-w-[820px] md:mt-8">
            {visibleItems.map((item) => {
              const isExpanded = expandedItems.has(item.value);
              return (
                <div
                  key={item.value}
                  className="mb-4 flex flex-col gap-2.5 rounded-2xl bg-[#F7FBFF] p-4"
                >
                  <div className="w-full text-left text-sm font-bold leading-normal text-[#333] md:text-base">
                    {item.question}
                  </div>
                  <div
                    className={`relative text-xs font-normal leading-normal text-[#999] md:text-sm ${
                      isExpanded ? "" : "max-h-[60px] overflow-hidden"
                    }`}
                  >
                    {item.answer}
                    {!isExpanded && (
                      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#F7FBFF] to-transparent" />
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => toggleExpand(item.value)}
                    className="inline-flex items-center gap-1 self-start border-0 bg-transparent p-0 text-xs font-bold text-[#39f] md:text-sm"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                    <span
                      className="inline-flex transition-transform duration-200"
                      style={{
                        transform: isExpanded ? "rotate(180deg)" : "none",
                      }}
                    >
                      <DownArrowIcon />
                    </span>
                  </button>
                </div>
              );
            })}

            {faqItems.length > 3 && (
              <button
                type="button"
                className="mx-auto mt-4 flex w-full items-center justify-center gap-1 border-0 bg-transparent p-0 text-sm font-bold text-[#39f]"
                onClick={() => setShowAllFaqs(!showAllFaqs)}
              >
                {showAllFaqs ? "See Less" : "See More"}
                <span
                  className="inline-flex transition-transform duration-200"
                  style={{ transform: showAllFaqs ? "rotate(180deg)" : "none" }}
                >
                  <DownArrowIcon />
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MilesCpaFAQ;
